import { render } from "./AddApprovisionnement.vue?vue&type=template&id=8f9557b2&scoped=true&ts=true"
import script from "./AddApprovisionnement.vue?vue&type=script&lang=ts"
export * from "./AddApprovisionnement.vue?vue&type=script&lang=ts"

import "./AddApprovisionnement.vue?vue&type=style&index=0&id=8f9557b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f9557b2"]])

export default __exports__